import SelectableCard, { SelectableCardOption } from './SelectableCard';

interface SingleProps {
  options: SelectableCardOption[];
  value: string | null;
  onChange: (value: string) => void;
  multiple?: false;
  variant?: 'plain' | 'icon' | 'compact';
  className?: string;
}

interface MultipleProps {
  options: SelectableCardOption[];
  value: string[];
  onChange: (value: string[]) => void;
  multiple: true;
  variant?: 'plain' | 'icon' | 'compact';
  className?: string;
}

type SelectableCardGroupProps = SingleProps | MultipleProps;

export default function SelectableCardGroup(props: SelectableCardGroupProps) {
  const { options, variant, className = 'space-y-3' } = props;

  const handleClick = (key: string) => {
    if (props.multiple) {
      const exists = props.value.includes(key);
      const next = exists
        ? props.value.filter((v) => v !== key)
        : [...props.value, key];
      props.onChange(next);
      return;
    }

    props.onChange(key);
  };

  const isActive = (key: string) => {
    if (props.multiple) return props.value.includes(key);
    return props.value === key;
  };

  return (
    <div className={className}>
      {options.map((option, idx) => (
        <SelectableCard
          key={option.key}
          option={option}
          active={isActive(option.key)}
          index={idx}
          variant={variant}
          onClick={() => handleClick(option.key)}
        />
      ))}
    </div>
  );
}
